import { render, staticRenderFns } from "./IconPause.vue?vue&type=template&id=0204883a&scoped=true"
import script from "./IconPause.vue?vue&type=script&lang=js"
export * from "./IconPause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204883a",
  null
  
)

export default component.exports